import { useEffect } from "react";

// Adds `in-view` to every `.mkt-fade-up` element as it scrolls into view.
export function useScrollReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".mkt-fade-up:not(.in-view)"));
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -6% 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
